import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'filesize', standalone: true })
export class FileSizePipe implements PipeTransform {
    private static SIZES = ['Bytes', 'KB', 'MB', 'GB'];
    transform(bytes: number): string {
        if (!bytes) return '0 Bytes';
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + FileSizePipe.SIZES[i];
    }
}